module.exports = __webpack_public_path__ + "assets/img/2.454b3d30.png";